import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import CusCard from '../components/CusCard'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';



class EventsAndReports extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <Container>
                <Row>
                    {/* <CusCard data1="My" data2="Graphs" icon="bar-chart" link="./GraphsSection"></CusCard> */}
                    {/* <CusCard data1="My" data2="Reports" icon="file-plus" link="./ManageReports"></CusCard> */}
                    {/* <CusCard data1="My Flagged" data2="Events" icon="grid" link="./MyFlaggedEvents"></CusCard> */}
                    {/* <CusCard data1="Notifications" data2="&nbsp;" icon="bell" link="./Notifications"></CusCard> */}
                    <CusCard data1="Fleet Overview" data2="Report" icon="credit-card" link="./GeneralReports" ></CusCard>
                    {/* <CusCard data1="Fleet Overview" data2="Report" icon="grid" link="./TrendReports"></CusCard> */}
                    <CusCard data1="Vehicle Movement" data2="Report" icon="minimize-2" link="./TrackerReport"></CusCard>
                    <CusCard data1="Suspicious" data2="Transactions Summary" icon="minimize-2" link="./SuspiciousReports?reportType=SuspiciousTransactionsSummary"></CusCard>
                </Row>

            </Container>




        );
    }
}


export default EventsAndReports;